import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import color from '@deprecated-ui/_style/color';

function LabelPro() {
  return (
    // @ts-expect-error
    <Button p="0px" margin="0 2px" round>
      <Text size="10px" color={color.suvaGrey} padding="2px">
        PRO
      </Text>
    </Button>
  );
}

export default LabelPro;
